export default __webpack_public_path__ + "static/media/mailchimp.f8270c35.svg";